import {
  InvitationSubrole,
  type InvitationRole,
} from 'uplisting-frontend/models/invitation';
import { UserRoles } from 'uplisting-frontend/models/user';

export type TeammateShapeKey = InvitationRole | InvitationSubrole;

export interface TeammateShape {
  key: TeammateShapeKey;
  role: InvitationRole;
  subrole: InvitationSubrole | null;
  faqTopic: string;
  showMultiUnits?: boolean;
  permission?: string;
  disableClientManaged?: boolean;
  showTurnoPromo?: boolean;
}

interface ShapedRecord {
  role: InvitationRole;
  subrole?: InvitationSubrole | null;
}

const HOST_FAQ = 'team-mates';
const HOUSEKEEPER_FAQ = 'cleaning_faqs';

export const TEAMMATE_SHAPES: readonly TeammateShape[] = [
  {
    key: UserRoles.host,
    role: UserRoles.host,
    subrole: null,
    faqTopic: HOST_FAQ,
    showMultiUnits: false,
  },
  {
    key: InvitationSubrole.reservations,
    role: UserRoles.host,
    subrole: InvitationSubrole.reservations,
    faqTopic: HOST_FAQ,
    showMultiUnits: false,
  },
  {
    key: InvitationSubrole.finance,
    role: UserRoles.host,
    subrole: InvitationSubrole.finance,
    faqTopic: HOST_FAQ,
    showMultiUnits: false,
  },
  {
    key: InvitationSubrole.operations,
    role: UserRoles.host,
    subrole: InvitationSubrole.operations,
    faqTopic: HOST_FAQ,
    showMultiUnits: false,
  },
  {
    key: UserRoles.housekeeper,
    role: UserRoles.housekeeper,
    subrole: null,
    faqTopic: HOUSEKEEPER_FAQ,
    showTurnoPromo: true,
  },
  {
    key: InvitationSubrole.maintenance,
    role: UserRoles.housekeeper,
    subrole: InvitationSubrole.maintenance,
    faqTopic: HOUSEKEEPER_FAQ,
  },
  {
    key: UserRoles.owner,
    role: UserRoles.owner,
    subrole: null,
    faqTopic: 'ownerclient-portal',
    permission: 'account.owner_users',
    disableClientManaged: true,
  },
];

export function shapesFor(presetsEnabled: boolean): TeammateShape[] {
  return TEAMMATE_SHAPES.filter(
    (shape) => presetsEnabled || shape.subrole === null,
  );
}

export function shapeKeyFor(
  record: ShapedRecord,
  presetsEnabled: boolean,
): TeammateShapeKey {
  const { role, subrole } = record;

  if (!presetsEnabled || !subrole) {
    return role;
  }

  const preset = TEAMMATE_SHAPES.find(
    (shape) => shape.subrole === subrole && shape.role === role,
  );

  return preset?.key ?? role;
}

export function selectableShapesFor(
  currentKey: TeammateShapeKey,
  presetsEnabled: boolean,
): TeammateShape[] {
  return shapesFor(presetsEnabled).filter(
    (shape) => shape.role !== UserRoles.owner && shape.key !== currentKey,
  );
}
